// extracted by mini-css-extract-plugin
export var container = "_ge-1";
export var cornerButtonContainer = "_ge-6";
export var disabled = "_ge-2";
export var dragActive = "_ge-3";
export var fileContainer = "_ge-5";
export var hiddenInput = "_ge-4";
export var widthContainer = "_ge-0";